import {
  checkQuery,
  normalizeRootQueryForStanleyMerge,
} from 'src/operations/query';
import { isEmpty } from 'src/utils';

type TargetWithQuery = {
  target_query?: {
    type?: string;
    arguments_list?: unknown[];
  };
};

/**
 * True when the selected target has no usable query content:
 * 1. No groups/rows at all (`arguments_list` is empty)
 * 2. Only empty group/row shells (blocks with no items inside)
 * 3. Only placeholder rows (`tmp_*` ids) or empty conversation rows
 */
export const isTargetQueryEmpty = (target?: TargetWithQuery): boolean => {
  if (!target?.target_query) return true;

  const normalized = normalizeRootQueryForStanleyMerge(target.target_query);

  if (isEmpty(normalized.arguments_list)) return true;

  return !checkQuery(normalized);
};
